<template><div class="local-qr" role="img" :aria-label="label" v-html="svg"></div></template>
<script>
import QRCode from 'qrcode'
export default {
  props: { value: { type: String, default: '' }, label: { type: String, default: 'Código QR' } },
  emits: ['ready'], data: () => ({ svg: '', generation: 0 }),
  watch: { value: { immediate: true, async handler(value) {
    const generation = ++this.generation; this.svg = ''
    if (!value) return
    try {
      const svg = await QRCode.toString(value, { type: 'svg', errorCorrectionLevel: 'M', margin: 4, color: { dark: '#172316', light: '#ffffff' } })
      if (generation === this.generation) { this.svg = svg; this.$emit('ready') }
    } catch (_e) { if (generation === this.generation) this.svg = '' }
  } } }
}
</script>
<style scoped>.local-qr { width: 100%; aspect-ratio: 1; background: white; }.local-qr :deep(svg) { display: block; width: 100%; height: 100%; }</style>
